import { Link } from 'react-router';
import classnames from '@common/utils/ui/classnames';

interface ApplicationTitleProps {
  title: string;
  /** Render only the small-screen home-link variant (used next to HeaderLinks). */
  mobileOnly?: boolean;
}

function ApplicationTitle({ title, mobileOnly = false }: Readonly<ApplicationTitleProps>) {
  return (
    <>
      {!mobileOnly && (
        <h4
          className={classnames({
            'page-header__title': true,
            'hide-screen-small': APP_TYPE !== 'alexa',
          })}
        >
          {title}
        </h4>
      )}
      {APP_TYPE !== 'alexa' && (
        <Link title={title} to="/" className="ph-no-capture page-header__link hide-screen-desktop">
          <h4 className="page-header__title">
            {title}
          </h4>
        </Link>
      )}
    </>
  );
}

export default ApplicationTitle;
